export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <path d="M24 3 42 9v14c0 11-8 18.5-18 22C14 41.5 6 34 6 23V9z" fill="#0F2A4A" />
    <path d="M24 11c1.1 6.6 3.2 8.8 9.6 9.9-6.4 1.1-8.5 3.3-9.6 9.9-1.1-6.6-3.2-8.8-9.6-9.9 6.4-1.1 8.5-3.3 9.6-9.9z" fill="#fff" />
    <rect x="18" y="34" width="12" height="2.2" fill="#CE2939" />
    <rect x="18" y="36.2" width="12" height="2.2" fill="#fff" />
    <rect x="18" y="38.4" width="12" height="2.2" fill="#477050" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <a href="#top" data-testid="header-logo-link" className="group flex items-center gap-3">
    <LogoMark className={`h-9 w-9 shrink-0 sm:h-10 sm:w-10 transition-transform duration-500 group-hover:-rotate-6 ${light ? "rounded-xl bg-white p-1" : ""}`} />
    <span className="leading-tight">
      <span className={`font-display block whitespace-nowrap text-[14px] font-extrabold tracking-tight sm:text-base ${light ? "text-white" : "text-[var(--navy)]"}`}>
        Magyar Extrém Takarítás
      </span>
      <span className={`hidden text-xs font-medium sm:block ${light ? "text-white/70" : "text-[var(--muted)]"}`}>magyar-extremtakaritas.hu</span>
    </span>
  </a>
);

export const WhatsAppIcon = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.32l-.34-.2-3.57.94.95-3.48-.22-.36A9.43 9.43 0 1 1 12.05 21.5zm8.02-17.46A11.27 11.27 0 0 0 1.82 17.6L.22 23.45l5.99-1.57a11.25 11.25 0 0 0 5.83 1.61A11.27 11.27 0 0 0 20.07 4.04z" />
  </svg>
);
